import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SeguroApiService {
  constructor(private http: HttpClient) { }

  calcularPrecioPorPoliza(polizaId: number): Promise<number | undefined> {
    return this.http.get<number>(`${environment.apiUrl}/seguro/calcular-precio-por-poliza?polizaId=${polizaId}`).toPromise();
  }
}